// @flow
import styled from '@emotion/styled';
import { SPACING } from '@tablekit/theme';
import { animated } from 'react-spring/web.cjs';
import { CoreLargeImageCard } from './static';

export const AnimatedLargeImageCard = animated(styled(CoreLargeImageCard)`
  position: absolute;
  top: 50%;
  left: 0;
`);

const height = 370;

export const CARD_DISPLAYS = [
  {
    minWidth: 0,
    displayCount: 1,
    height,
    gutter: parseInt(SPACING.L3, 10)
  },
  {
    minWidth: 576,
    displayCount: 2,
    height,
    gutter: parseInt(SPACING.L4, 10)
  },
  {
    minWidth: 768,
    displayCount: 3,
    height,
    gutter: parseInt(SPACING.L4, 10)
  },
  {
    minWidth: 1024,
    displayCount: 3,
    height,
    gutter: parseInt(SPACING.L4, 10)
  },
  {
    minWidth: 1280,
    displayCount: 4,
    height,
    gutter: parseInt(SPACING.L5, 10)
  },
  {
    minWidth: 1440,
    displayCount: 5,
    height,
    gutter: parseInt(SPACING.L5, 10)
  }
];
